import React, { useEffect } from 'react';
import LegalLayout from '../../layouts/LegalLayout/LegalLayout';
import TermsConditionsContent from './TermsConditionsContent';
import PrivacyPolicyContent from '../PrivacyPolicyPage/PrivacyPolicyContent';

const TermsConditionsPage: React.FC = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout>
      <TermsConditionsContent />
      <PrivacyPolicyContent />
    </LegalLayout>
  );
};

export default TermsConditionsPage;